import { defineStore } from "pinia";
import { PainelDeIntegracaoesGateway } from "../views/painel/services/PainelDeIntegracaoesGateway";
import { IFinancasFeatureGateway } from "@/features/financas/services/ports/FinancasFeatureGateway";
import { CadastroDeIntegracaoGateway } from "../views/painel/widgets/cadastro/services/CadastroDeIntegracaoGateway";

export const idStore = "useIntegracoesStore";

interface IIntegracoesStore {
  isLoading: boolean;
  listaWebservicesOpt: { label: string; value: number }[];
  listaFornecedoresConfiaveisOpt: { label: string; value: string }[];
  municipiosOpt: { label: string; value: string }[];
}

export const useIntegracoesStore = defineStore(idStore, {
  state: (): IIntegracoesStore => ({
    isLoading: false,
    listaWebservicesOpt: [],
    listaFornecedoresConfiaveisOpt: [],
    municipiosOpt: []
  }),

  getters: {},
  actions: {
    setLoading(val: boolean) {
      this.isLoading = val;
    },
    setListaWebservicesOpt(val: { Id: number; Value: string }[]) {
      this.listaWebservicesOpt = val.map((item) => ({
        label: item.Value,
        value: item.Id
      }));
    },
    async obterListaWebservices(gateway: PainelDeIntegracaoesGateway) {
      try {
        this.isLoading = true;
        const response = await gateway.obterListaWebservices();
        if (response && response.Result) {
          this.setListaWebservicesOpt(response.Result);
        }
      } catch (error) {
        console.error(error);
        this.listaWebservicesOpt = [];
      } finally {
        this.isLoading = false;
      }
    },
    async obterFornecedoresConfiaveis(gateway: IFinancasFeatureGateway) {
      const response = await gateway.getFornecedoresConfiaveis();

      if (response && response.Data) {
        this.listaFornecedoresConfiaveisOpt = response.Data.map((item) => ({
          label: item.Nome,
          value: item._id
        }));
      }
    },
    async obterMunicipiosOpt(gateway: CadastroDeIntegracaoGateway) {
      const response = await gateway.obterMunicipiosOpt();

      if (response && response.Result) {
        this.municipiosOpt = response.Result.map((item) => ({
          label: item.Value,
          value: item.Id.toString()
        }));
      }
    }
  }
});
